module.exports = __webpack_public_path__ + "img/kjm.a948579f.png";